import { some } from '@utils/some';
import { FormStep } from '../../../components/BookingForms';
import { ExtrasStep, MultiRoomExtrasStep } from './ExtrasStep';
import { GuestDetailsStep } from './GuestDetailsStep';
import { MultiRoomGuestDetailsStep } from './MultiRoomGuestDetailsStep';

export const STICKY_BAR_ID = 'room-details-sticky-bar';

export enum RoomRateFormStepNames {
  GUESTS = 'guestDetailsStep',
  EXTRAS = 'extras',
}

export const getFormSteps = ({
  isSignInModalOpen,
  basketGuests,
  journeyParams,
  addToBasket,
  setIsSignInModalOpen,
  metaEntity,
  entity,
  goToNextStep,
  totalGuestAmount,
  availableExtras,
}) => {
  const entities = metaEntity.rates || metaEntity.rooms;
  const selectedEntity =
    entities?.find(({ rateId }) => String(entity.id) === String(rateId)) ||
    entities?.find(({ id }) => String(entity.id) === String(id));

  const isMultiRoom = some(journeyParams.rooms) && journeyParams.rooms.length > 1;
  const totalRooms = journeyParams.rooms.length;
  const extrasProps = {
    selectedEntity: selectedEntity,
    stickyBarId: STICKY_BAR_ID,
    addToBasket: addToBasket,
    goToNextStep: goToNextStep,
    metaEntity: metaEntity,
    entity: entity,
    availableExtras: availableExtras,
    isMultiRoom,
  };

  const guestsProps = {
    selectedEntity: selectedEntity,
    stickyBarId: STICKY_BAR_ID,
    basketGuests: basketGuests,
    datePartyData: journeyParams,
    addToBasket: addToBasket,
    goToNextStep: goToNextStep,
    isSignInModalOpen: isSignInModalOpen,
    handleSignInModalOpen: () => setIsSignInModalOpen(true),
    metaEntity: metaEntity,
    availableExtras: availableExtras,
    totalGuestAmount: totalGuestAmount,
  };
  return {
    [RoomRateFormStepNames.GUESTS]: (
      <FormStep isNarrow noGutter key={0}>
        {isMultiRoom ? (
          <MultiRoomGuestDetailsStep
            {...guestsProps}
            initalValues={{
              guests: new Array(totalRooms).fill({}),
            }}
          />
        ) : (
          <GuestDetailsStep
            {...guestsProps}
            initialValues={{
              guests: new Array(totalGuestAmount).fill({}),
            }}
          />
        )}
      </FormStep>
    ),
    [RoomRateFormStepNames.EXTRAS]: (
      <FormStep isNarrow noGutter key={1}>
        {isMultiRoom ? <MultiRoomExtrasStep {...extrasProps} /> : <ExtrasStep {...extrasProps} />}
      </FormStep>
    ),
    '': <></>,
  };
};
